/**
 * 批量上传中用到的excel文件上传组件
 * */

import React, { useState } from "react";
import style from "./index.module.scss";
import { Button, Icon, Upload } from "antd";
import { RcFile, UploadProps } from "antd/lib/upload/interface";
import { ResultMessage } from "../../ResultMessage";

interface Props extends UploadProps {
    onDeleteFile: () => void; //点击删除
    setFile: (val: File) => void;
}

export default function UploadExcel({
    onDeleteFile,
    setFile,
    ...resProps
}: Props) {
    const { Dragger } = Upload;
    const [isShowExcel, setIsShowExcel] = useState(false);
    const [fileName, setFileName] = useState(""); //文件名

    //自定义上传方式（不走接口需要先取到file）
    function customerRequest(e: any) {
        setFile(e.file);
        setFileName(e.file.name);
        setIsShowExcel(true);
    }

    function beforeUpload(file: RcFile) {
        const fileSuffix = ["xlsx", "XLSX", "xls"];
        const fileNameIndex = file.name.lastIndexOf(".");
        const suffix = file.name.slice(fileNameIndex + 1);
        const is5M = file.size / 1024 / 1024 < 5;

        if (!fileSuffix.includes(suffix)) {
            ResultMessage.error(`只能上传 excel 格式的 Excel 文件`);
            return false;
        }

        if (!is5M) {
            ResultMessage.error(`${file.name}文件大小超出5M，请修改后重新上传`);
            return false;
        } else {
            return true;
        }
    }

    function onDelete() {
        setIsShowExcel(false);
        onDeleteFile();
    }

    return (
        <div className={style.root}>
            {!isShowExcel && (
                <Dragger
                    name="file"
                    multiple={false} //是否支持多文件上传
                    showUploadList={false} //是否展示文件列表
                    beforeUpload={beforeUpload} //上传文件之前的钩子
                    accept={".xlsx, .XLSX, .xls"}
                    customRequest={customerRequest}
                    {...resProps}>
                    <div className={style.content}>
                        <div className={style.title}>
                            点击或将文件拖拽到这里上传
                            <span className={style.subTitle}>
                                (只支持单个文件上传)
                            </span>
                        </div>
                        <div className={style.title2}>
                            当前Excel导入数据量上限为5万条，文件大小上限为5M
                        </div>
                    </div>
                </Dragger>
            )}

            {isShowExcel && (
                <div className={style.showExcel}>
                    <div className={style.fileDiv}>
                        <img
                            src={require("./img/excel.png")}
                            className={style.excelIcon}
                        />
                        <span className={style.fileName}>{fileName}</span>
                        <Button type="link" onClick={() => onDelete()}>
                            <Icon type="delete" />
                        </Button>
                    </div>
                    <div className={style.excelTitle}>
                        当前Excel导入数据量上限为5万条，文件大小上限为5M,仅支持单个文件上传
                    </div>
                </div>
            )}
        </div>
    );
}
